"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlDocumentBox", function (fileUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      document: "<"
    },
    transclude: true,
    template: require("./tlDocumentBox.html"),
    controllerAs: "$ctrl",
    controller: function controller($scope, $translate, $filter) {
      var ctrl = this;
      $scope.renderType = function (document) {
        if (document.tags && document.tags.DATE_ECHEANCE) {
          return $translate("lov.typesDocuments." + document.type) + " " + $translate("lov.typesDocuments.DU", {
            'date': $filter("dateShort")(document.tags.DATE_ECHEANCE)
          });
        }
        return $translate("lov.typesDocuments." + document.type);
      };
      ctrl.getIcon = function () {
        var ext = fileUtils.getExtension($scope.document.url ? $scope.document.url : $scope.document.fileId);
        return fileUtils.getExtensionIcon(ext);
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/documents/tlDocumentBox.js
// module id = 2777
// module chunks = 13